var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.urlVideo)?_c('video',{ref:"video",staticClass:"borderBanner",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":(_vm.linkStorage + "/" + _vm.urlVideo + ".mp4"),"type":"video/mp4"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }